<template>
  <div class="alarm-record">
    <el-card>
      <div slot="header">
        <span>告警记录</span>
      </div>

      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="告警级别">
          <el-select v-model="searchForm.level" placeholder="请选择" clearable>
            <el-option label="高" value="high"></el-option>
            <el-option label="警告" value="warning"></el-option>
            <el-option label="提示" value="info"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="处理状态">
          <el-select v-model="searchForm.status" placeholder="请选择" clearable>
            <el-option label="未处理" value="pending"></el-option>
            <el-option label="已处理" value="handled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围">
          <el-date-picker
            v-model="searchForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="alarmList" border style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="deviceName" label="设备名称" width="150"></el-table-column>
        <el-table-column prop="alarmType" label="告警类型" width="120">
          <template slot-scope="scope">
            {{ getAlarmTypeName(scope.row.alarmType) }}
          </template>
        </el-table-column>
        <el-table-column prop="level" label="告警级别" width="100">
          <template slot-scope="scope">
            <el-tag :type="getLevelType(scope.row.level)" size="small">
              {{ getLevelName(scope.row.level) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="message" label="告警信息"></el-table-column>
        <el-table-column prop="alarmTime" label="告警时间" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.alarmTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 'pending' ? 'danger' : 'success'" size="small">
              {{ scope.row.status === 'pending' ? '未处理' : '已处理' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === 'pending'" size="mini" type="text" @click="handleProcess(scope.row)">处理</el-button>
            <el-button size="mini" type="text" @click="handleView(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;"
      >
      </el-pagination>
    </el-card>

    <el-dialog title="处理告警" :visible.sync="processDialogVisible" width="500px">
      <el-form :model="processForm" ref="processForm" label-width="100px">
        <el-form-item label="处理方式">
          <el-radio-group v-model="processForm.handleType">
            <el-radio label="resolved">已解决</el-radio>
            <el-radio label="ignored">忽略</el-radio>
            <el-radio label="escalated">转上级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="处理备注">
          <el-input v-model="processForm.remark" type="textarea" :rows="4" placeholder="请输入处理备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="processDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitProcess">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'AlarmRecord',
  data() {
    return {
      searchForm: {
        level: '',
        status: '',
        dateRange: []
      },
      alarmList: [],
      loading: false,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      processDialogVisible: false,
      processForm: {
        id: null,
        handleType: 'resolved',
        remark: ''
      }
    }
  },
  mounted() {
    this.fetchAlarms()
  },
  methods: {
    async fetchAlarms() {
      this.loading = true
      try {
        // 只传非空筛选条件，避免空字符串导致后端匹配不到任何记录
        const params = {
          page: this.pagination.page,
          size: this.pagination.size
        }
        if (this.searchForm.level) params.level = this.searchForm.level
        if (this.searchForm.status) params.status = this.searchForm.status
        const res = await api.getAlarms(params)
        this.alarmList = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        this.alarmList = this.getMockAlarms()
        this.pagination.total = this.alarmList.length
      } finally {
        this.loading = false
      }
    },
    getMockAlarms() {
      const types = ['temperature', 'humidity', 'smoke', 'door', 'OFFLINE', 'ONLINE']
      const typeNames = ['温度异常', '湿度异常', '烟雾告警', '门磁告警', '设备离线', '设备上线']
      const levels = ['high', 'warning', 'info']
      const devices = ['设备1', '设备2', '设备3', '设备4', '设备5']
      const statusList = ['pending', 'handled']
      const handlerName = '管理员'
      const alarms = []
      for (let i = 0; i < 15; i++) {
        const isPending = i % 3 === 0
        alarms.push({
          id: i + 1,
          deviceName: devices[i % 5],
          alarmType: types[i % 6],
          level: levels[i % 3],
          message: '检测到' + typeNames[i % 6] + '，当前数值超过阈值',
          alarmTime: new Date(Date.now() - Math.random() * 86400000 * 7).toLocaleString(),
          status: isPending ? statusList[0] : statusList[1],
          handleTime: isPending ? null : new Date().toLocaleString(),
          handler: isPending ? null : handlerName
        })
      }
      return alarms
    },
    getAlarmTypeName(type) {
      const map = {
        temperature: '温度异常',
        humidity: '湿度异常',
        smoke: '烟雾告警',
        door: '门磁告警',
        offline: '设备离线',
        OFFLINE: '设备离线',
        ONLINE: '设备上线'
      }
      return map[type] || type
    },
    getLevelType(level) {
      const map = {
        high: 'danger',
        warning: 'warning',
        info: 'info'
      }
      return map[level] || 'info'
    },
    getLevelName(level) {
      const map = {
        high: '高',
        warning: '警告',
        info: '提示'
      }
      return map[level] || level
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchAlarms()
    },
    handleReset() {
      this.searchForm = { level: '', status: '', dateRange: [] }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchAlarms()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchAlarms()
    },
    handleProcess(row) {
      this.processForm = {
        id: row.id,
        handleType: 'resolved',
        remark: ''
      }
      this.processDialogVisible = true
    },
    handleView(row) {
      this.$alert(`
        <p><strong>设备名称：</strong>${row.deviceName}</p>
        <p><strong>告警类型：</strong>${this.getAlarmTypeName(row.alarmType)}</p>
        <p><strong>告警级别：</strong>${this.getLevelName(row.level)}</p>
        <p><strong>告警信息：</strong>${row.message}</p>
        <p><strong>告警时间：</strong>${this.formatDate(row.alarmTime)}</p>
        <p><strong>处理状态：</strong>${row.status === 'pending' ? '未处理' : '已处理'}</p>
      `, '告警详情', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true
      })
    },
    async handleSubmitProcess() {
      try {
        await api.handleAlarm(this.processForm.id, {
          handleType: this.processForm.handleType,
          handleRemark: this.processForm.remark,
          handler: '管理员'
        })
        this.$message.success('处理成功')
        this.processDialogVisible = false
        this.fetchAlarms()
      } catch (error) {
        this.$message.error('处理失败')
      }
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
  }
}
</script>
